// Message Model
cv.Message =  Backbone.RESTModel.extend({
  defaults : {
    'draft' : '',
    'body' : '',
  },

  saveMap : {
    'title' : 'title',
    'draft' : 'draft',
    'body' : 'body',
    'contact_id' : 'contact_id'
  },

  urlRoot: function(){
    return cv.api_path + '/messages';
  },

  initialize: function(){
    console.log('Message model initialized.');
  }
});
Cocktail.mixin(cv.Message, cv.mixins.SyncModel);

// Messages Collection
cv.Messages = Backbone.Collection.extend({
  initialize: function(options){
    console.log('Messages collection initialized.');
  },

  url: function() {
    return cv.api_path + "/messages?" + $.param(this.params);
  },

  model: cv.Message
});
Cocktail.mixin(cv.Messages, cv.mixins.PaginateModel);
